import script from "./PromptSnippetImportExport.vue?vue&type=script&setup=true&lang=js"
export * from "./PromptSnippetImportExport.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__